import { jsx as _jsx } from "react/jsx-runtime";
import { CountryFlag } from '@dixa/lib-shared-habla';
import { getCountryCodeFromPhoneNumber } from 'lib-shared-phone-numbers';
import styles from './phoneNumberCountryFlag.module.scss';
/** A component that returns the country flag corresponding to a phone number. */
export const PhoneNumberCountryFlag = ({ phoneNumber, size = 20, }) => {
    const countryCode = phoneNumber
        ? getCountryCodeFromPhoneNumber(phoneNumber)
        : undefined;
    return (_jsx(CountryFlag, { className: countryCode ? undefined : styles.transparent, countryCode: countryCode !== null && countryCode !== void 0 ? countryCode : 'dk', size: size }));
};
